import { render, staticRenderFns } from "./CourseEditorQuizzInput.vue?vue&type=template&id=9f8ae088"
import script from "./CourseEditorQuizzInput.vue?vue&type=script&lang=js"
export * from "./CourseEditorQuizzInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports